<template>
    <div class="image-component" :class="{ 'disabled-image-action': disabled }" :style="{ 'background-color': bg }">
        <img v-if="isButtun" :src="url" :alt="'path image cars'" class="btn btn-sm p-0 img-btn" />

        <img v-else class="btn btn-sm p-0 img-btn" :src="url" :alt="'path image cars'" />
    </div>
</template>

<script>
export default {

    name: 'IconsAction',
    emits: ['click'],
    props: {
        bg: {
            type: String,
            default: 'white'
        },
        width: {
            type: String,
            default: '24px'
        },
        url: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isButtun: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.bg-color {
    background-color: v-bind(bg);
}



.image-component.disabled-image-action {
    pointer-events: none;
    cursor: not-allowed;

}

.image-component.disabled-image-action img {
    opacity: 0.7;


}

.image-component img {
    width: v-bind(width);
}

.box-img {
    box-shadow: 1px 1px 2px #00000038, inset 1px 1px 2px #e5e5e5cc;
    border-radius: 7px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #c9c9c985;
}

.image-component {
    width: fit-content;
    max-width: 70px;
    border-radius: 4px;
    transition: background-color 0.3s ease;
}

.image-component img {
    max-width: 100%;
    height: auto;
    transform: scale(1);
    transition: background-color 0.3s ease;

}

.image-component img.img-btn:hover {

    transform: scale(1.1);
    transition: background-color 0.3s ease;
}

.image-component img.img-btn:active {
    background-color: #e0e0e0;
    transition: background-color 0.2s ease;
}

.image-component img.img-btn:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.5);
}
</style>